const SPEC_FIELDS = {
  Procesor: 'Procesor', Grafika: 'Grafika', Text: 'Tryb tekstowy', ROM: 'ROM', RAM: 'RAM',
  Dzwiek: 'Dźwięk', Wyjscia: 'Złącza', System: 'System operacyjny',
  RokProdukcji: 'Rok produkcji',
};

export function getCollectionSpecRows(item = {}) {
  const rows = Object.entries(SPEC_FIELDS)
    .filter(([key]) => item[key] !== null && item[key] !== undefined && String(item[key]).trim() !== '')
    .map(([key, label]) => ({ label, value: String(item[key]) }));
  const ending = item.RokZakonczenia || item.RakZakonczenia;
  if (String(ending || '').trim()) rows.push({ label: 'Koniec produkcji', value: String(ending) });
  return rows;
}

export function getCollectionDescription(item = {}) {
  return item.summary || item.Opis || 'Ten opis czeka na uzupełnienie.';
}

export function getCollectionHeroImageUrl(item = {}, strapiURL = '') {
  const photo = item?.coverPhoto || item?.Photos?.[0];
  const imagePath = photo?.formats?.large?.url || photo?.formats?.medium?.url || photo?.formats?.small?.url || photo?.url || '';

  return imagePath ? `${strapiURL}${imagePath}` : '';
}

export function hasCollectionPhotos(item = {}) {
  return Array.isArray(item.Photos) && item.Photos.length > 0;
}

export function getCollectionSources(item = {}) {
  if (!Array.isArray(item.sources)) return [];
  return item.sources
    .filter((source) => source && typeof source === 'object' && typeof source.url === 'string' && /^https?:\/\//i.test(source.url))
    .map((source) => ({ label: String(source.label || source.url), url: source.url, note: String(source.note || '') }));
}

export function getCollectionReturnPath(location = {}) {
  const statePath = location.state?.from || '';
  if (/^\/collection(?:\?|$)/.test(statePath)) return statePath;

  const source = new URLSearchParams(location.search || '');
  const allowed = new URLSearchParams();
  for (const key of ['q', 'kind', 'maker', 'sort', 'page']) {
    const value = source.get(key);
    if (value) allowed.set(key, value);
  }
  const query = allowed.toString();
  return `/collection${query ? `?${query}` : ''}`;
}
